import type { PackagesListFiltersValue } from '@openx/types/package.ts';
import {
  CriteriaDimension,
  type PaginationCriteria,
  type SortCriteria,
  SortDirection,
} from '@openx/types/tableCriteria.ts';

import { TABLE_PAGE_SIZE } from '../../../../config.ts';

type PackagesListCriteria = {
  [CriteriaDimension.SORT]: SortCriteria;
  [CriteriaDimension.FILTERS]: PackagesListFiltersValue;
  [CriteriaDimension.PAGINATION]: PaginationCriteria;
};

export const defaultCriteria: PackagesListCriteria = {
  [CriteriaDimension.SORT]: {
    column: 'name',
    direction: SortDirection.DESC,
    sortableColumns: ['name', 'rate_card_cpm', 'discounted_cpm'],
  },
  [CriteriaDimension.FILTERS]: {
    phrase: '',
  },
  [CriteriaDimension.PAGINATION]: {
    pageNumber: 1,
    pageSize: TABLE_PAGE_SIZE,
    totalCount: 500,
  },
};
